import { Button } from "@material-ui/core";
import Grid from "@material-ui/core/Grid";
import withStyles from "@material-ui/core/styles/withStyles";
import Tab from "@material-ui/core/Tab";
import Tabs from "@material-ui/core/Tabs";
import Helmet from "react-helmet";
import headersList from "Constants/headersList";
import { withSnackbar } from "notistack";
import React from "react";
import get from "lodash/get";
import { FormattedMessage, IntlProvider } from "react-intl";
import { connect } from "react-redux";
import { Route, Switch } from "react-router-dom";
import { bindActionCreators } from "redux";
import emptylist from "Assets/Svg/illustration-no-policy.svg";
import PermissionDeniedComp from "Component/PermissionDeniedComp/PermissionDeniedComp";
import { instance } from "../../../../../Actions/AxiosInstance";
import {
  CheckActionPermission,
  CommonApiAction,
  CommonReducerAction,
  WeekoffPlanner,
} from "../../../../../Actions/commonAction";
import { ChangeLanguage } from "../../../../../Actions/LanguageAction";
import WeeklyOffIMg from "../../../../../Assets/Images/relaxing_at_home.svg";
import PageNotFound from "../../../../../Component/NotFound/index";
import Stepper from "../../../../../Component/Stepper/index";
import { ApiReducerType, ReducersTypes } from "../../../../../Constants";
import {
  CreateComp,
  List,
  TDTypeConsts,
} from "../../../business-configration/commons";
import Accumulation from "./Accumulation";
import Define from "./Define";
import Preview from "./Preview";
import WeeklyNameAndDescription from "./WeeklyNameAndDescription";

const styles = () => ({
  root: {
    flexGrow: 1,
    width: "100%",
  },
});

class WeeklyOff extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      list: [],
      value: 0,
      parentid: null,
      currentRoute: "list",
      weekoffpolicyname: "",
      weekoffpolicyid: "",
      description: "",
      actionidList: "",
      headers: [
        {
          key: "weekoffpolicyname",
          name: (
            <FormattedMessage
              id="HtWeeklyoffName"
              defaultMessage="Weekly-off Name"
            />
          ),
          type: TDTypeConsts.EDIT_NAME,
          style: { textAlign: "left" },
        },
        {
          key: "addedbyimagepath",
          name: (
            <FormattedMessage id="HtCreatedBy" defaultMessage="Created By" />
          ),
          type: TDTypeConsts.CREATED_BY,
        },
        {
          key: "assignedEmployeeList",
          name: (
            <FormattedMessage
              id="LbAssignedEmployee"
              defaultMessage="Assigned Employee"
            />
          ),
          type: TDTypeConsts.ASSIGNED_USER,
          style: { padding: "0" },
        },
        // { key: 'shifttiming', name: <FormattedMessage id="LbShiftTime" defaultMessage="Shift Time" />, type: TDTypeConsts.SHIFT_TIME, style: { textAlign: 'center' } },
        // { key: 'versioncount', name: <FormattedMessage id="LbVersions" defaultMessage="Versions" />, type: TDTypeConsts.VERSIONS }
      ],
      AllStep: [
        {
          step: 1,
          component: (
            <WeeklyNameAndDescription
              onRef={(ref) =>
                this.setState({
                  child0: {
                    ...ref,
                    onCancel: this.OnCancel,
                    onSaveDraft: this.OnSaveDraft,
                  },
                })
              }
              StepError={this.StepError.bind(this)}
              click={this.onClick}
              {...this.props}
            />
          ),
          label: <FormattedMessage id="LbDescribe" defaultMessage="Describe" />,
          isError: false,
        },
        {
          step: 2,
          component: (
            <Define
              onRef={(ref) =>
                this.setState({
                  child1: {
                    ...ref,
                    onCancel: this.OnCancel,
                    onPrev: this.onPrevClick,
                    onSaveDraft: this.OnSaveDraft,
                  },
                })
              }
              StepError={this.StepError.bind(this)}
              click={this.onClick}
              {...this.props}
            />
          ),
          label: <FormattedMessage id="HtDefine" defaultMessage="Define" />,
          isError: false,
        },
        {
          step: 3,
          component: (
            <Accumulation
              onRef={(ref) =>
                this.setState({
                  child2: {
                    ...ref,
                    onCancel: this.OnCancel,
                    onPrev: this.onPrevClick,
                    onSaveDraft: this.OnSaveDraft,
                  },
                })
              }
              StepError={this.StepError.bind(this)}
              click={this.onClick}
              {...this.props}
            />
          ),
          label: (
            <FormattedMessage
              id="HtAccumulation"
              defaultMessage="Accumulation"
            />
          ),
        },
        {
          step: 4,
          component: (
            <Preview
              onRef={(ref) =>
                this.setState({
                  child3: {
                    ...ref,
                    onCancel: this.OnCancel,
                    onPrev: this.onPrevClick,
                    onSaveDraft: this.OnSaveDraft,
                    onNext: this.OnSave,
                    nextButtonLabel: "Save",
                  },
                })
              }
              StepError={this.StepError.bind(this)}
              click={this.onClick}
              {...this.props}
            />
          ),
          label: <FormattedMessage id="HtPreview" defaultMessage="Preview" />,
        },
      ],
      completed: {},
      weekoffdays: [],
      isPreviewEdit: true,
      permissions: { readOnly: false, editable: false },
    };
    this.OnCancel = this.OnCancel.bind(this);
    this.onBeforeUpload = this.onBeforeUpload.bind(this);
  }

  componentWillMount() {
    this.props.history.push(`${this.props.match.path}/list`);
    this.props.ChangeLanguage("weekoff,navigation");
  }

  componentDidMount() {
    window.addEventListener("beforeunload", this.onBeforeUpload);
    const [isTrue, permissions] = CheckActionPermission("weeklyOff");
    if (isTrue) {
      this.setState({ permissions });
      // this.CheckActiveSteps()
      const verObject = {
        key: "versioncount",
        name: <FormattedMessage id="HtVersions" defaultMessage="Versions" />,
        type: TDTypeConsts.VERSIONS,
      };
      this.state.headers.push(verObject);
      if (this.props.history.location.pathname.includes("versions")) {
        console.log("111");
        this.props.history.push(`${this.props.match.path}/list`);
        this.setState({ currentRoute: "list", parentid: null }, () => {
          this.props.CommonApiAction(
            ApiReducerType.WEEKOFFTPLANNER,
            "get",
            "subscription/getallweekoffpolicy/1",
            {},
          );
          // setTimeout(() => {
          //     if (this.props.WEEKOFFTPLANNER.Data.length == 0) {
          //         this.props.CommonApiAction(ApiReducerType.WEEKOFFTPLANNER, 'get', 'subscription/getallweekoffpolicy/1', {})
          //         this.handleChange(null, 1)
          //     }
          //     else {
          //         this.handleChange(null, 0)
          //     }
          // }, 1500)
        });
      } else if (this.props.history.location.pathname.includes("list")) {
        // this.props.GetAllWeekoff('subscription/getallweekoffpolicy/1')
        // this.props.CommonApiAction(ApiReducerType.WEEKOFFTPLANNER, 'get', 'subscription/getallweekoffpolicy/1', {})
        this.setState({ currentRoute: "list", parentid: null }, () => {
          this.props.CommonApiAction(
            ApiReducerType.WEEKOFFTPLANNER,
            "get",
            "subscription/getallweekoffpolicy/1",
            {},
          );
          // setTimeout(() => {
          //     if (this.props.WEEKOFFTPLANNER.Data.length == 0) {
          //         this.props.CommonApiAction(ApiReducerType.WEEKOFFTPLANNER, 'get', 'subscription/getallweekoffpolicy/1', {})
          //         this.handleChange(null, 1)
          //     }
          //     else {
          //         this.handleChange(null, 0)
          //     }
          // }, 1500)
        });
      } else {
        // Do nothing on create
      }
    } else {
      // this.props.history.push('404')
      this.setState({ permissiondenied: true });
    }
  }

  componentWillUnmount() {
    window.removeEventListener("beforeunload", this.onBeforeUpload);
  }

  onBeforeUpload(e) {
    e.returnValue = "Are you sure you want to close the window/tab?";
  }

  componentWillReceiveProps(props) {
    if (props.history.location.pathname.includes("list")) {
      this.setState({ weekoffpolicyname: "" });
    } else if (props.history.location.pathname.includes("versions")) {
      this.setState({ weekoffpolicyname: "Versions" });
    } else if (
      props.history.location.pathname.includes("create") ||
      props.history.location.pathname.includes("view")
    ) {
      const weekoffPlannerInfo = props.weekoffPlannerReducer;
      const weekoffpolicyname = weekoffPlannerInfo.weekoffpolicyname
        ? weekoffPlannerInfo.weekoffpolicyname
        : "";
      this.setState({ weekoffpolicyname });
    } else {
      console.log("222");
      this.props.history.push(`${this.props.match.path}/list`);
    }

    if (!props.history.location.pathname.includes(this.state.currentRoute)) {
      if (props.history.location.pathname.includes("list")) {
        this.props.CommonReducerAction(ReducersTypes.CLEARWEEKOFF);
        if (this.state.parentid) {
          const index = this.state.headers.findIndex((x) => x.key == "version");
          this.state.headers.splice(index, 1);
          this.state.headers.push(
            {
              key: "assignedEmployeeList",
              name: "Assigned User",
              type: TDTypeConsts.ASSIGNED_USER,
              style: { padding: "0" },
            },
            {
              key: "versioncount",
              name: "Versions",
              type: TDTypeConsts.VERSIONS,
            },
          );
          this.setState({ currentRoute: "list", parentid: null });
          // this.state.headers[0].type = TDTypeConsts.EDIT_NAME;
        }
        let status;
        this.state.value == 0
          ? (status = 1)
          : this.state.value == 1
          ? (status = 2)
          : (status = 0);
        // this.props.GetAllWeekoff('subscription/getallweekoffpolicy/' + status)
        this.props.CommonApiAction(
          ApiReducerType.WEEKOFFTPLANNER,
          "get",
          `subscription/getallweekoffpolicy/${status}`,
          {},
        );
      } else if (props.history.location.pathname.includes("versions")) {
        // this.props.history.push(`${this.props.match.path}/list`);
        this.props.CommonReducerAction(ReducersTypes.CLEARWEEKOFF);
        this.setState({ currentRoute: "versions" }, () => {
          if (!this.state.parentid) {
            console.log("333");
            this.props.history.push(`${this.props.match.path}/list`);
          }
          const verObject = {
            key: "version",
            name: "Version",
            type: TDTypeConsts.OTHERS,
          };
          const index = this.state.headers.findIndex(
            (x) => x.key == "versioncount",
          );
          this.state.headers.splice(index, 1);
          const indexlist = this.state.headers.findIndex(
            (x) => x.key == "assignedEmployeeList",
          );
          this.state.headers.splice(indexlist, 1);
          this.state.headers.push(verObject);
          // this.state.headers[0].type = TDTypeConsts.EDIT_NAME;
          // this.props.GetAllWeekoff('attendance/shiftversionbyparentid/' + this.state.parentid)
          this.props.CommonApiAction(
            ApiReducerType.WEEKOFFTPLANNER,
            "get",
            `subscription/weekoffversions/${this.state.parentid}`,
            {},
          );
          // check
        });
      }
    }
  }

  BackFromVersionViewMode = () => {
    this.props.history.push("../versions");
  };

  onVersionChange = (parentid) => {
    const { match } = this.props;
    this.setState({ parentid }, () => {
      console.log("444");
      this.props.history.push(`${match.path}/versions`);
      // this.props.GetAllWeekoff('attendance/shiftversionbyparentid/' + this.state.parentid)
      this.props.CommonApiAction(
        ApiReducerType.WEEKOFFTPLANNER,
        "get",
        `subscription/weekoffversions/${this.state.parentid}`,
        {},
      );
    });
  };

  DeleteWeekOffPlan() {
    const HolidayInfo = this.props.weekoffPlannerReducer;
    const URL = `subscription/weekoffpolicy/${HolidayInfo.holidayplanid}/${HolidayInfo.holidayyear}`;
    instance
      .delete(URL)
      .then(() => {
        this.props.enqueueSnackbar("Holiday plan deleted successfully", {
          variant: "success",
        });
        this.OnCancel();
      })
      .catch((error) => {
        const CommonError = error.response
          ? error.response.data.error.message
          : error.message;
        this.props.enqueueSnackbar(CommonError, { variant: "error" });
      });
  }

  handleChange = (event, value) => {
    if (this.state.value == value) {
      return false;
    }
    // this.props.CommonReducerAction('CLEARWEEKOFF', {})
    let status;
    value == 0 ? (status = 1) : value == 1 ? (status = 2) : (status = 0);
    this.UpdateHeaderData(status);
    // this.setState({ value }, () => this.props.GetAllWeekoff('subscription/getallweekoffpolicy/' + status));
    this.setState({ value }, () => {
      this.props.CommonApiAction(
        ApiReducerType.WEEKOFFTPLANNER,
        "get",
        `subscription/getallweekoffpolicy/${status}`,
        {},
      );
    });
  };

  UpdateHeaderData(status) {
    if (status == 1) {
      const filteredHeader = this.state.headers.filter(
        (x) => x.key == "assignedEmployeeList",
      );
      if (filteredHeader.length == 0) {
        const col1 = {
          key: "assignedEmployeeList",
          name: (
            <FormattedMessage
              id="HtAssignedUser"
              defaultMessage="Assigned User"
            />
          ),
          type: TDTypeConsts.ASSIGNED_USER,
          style: { padding: "0" },
        };
        this.state.headers.splice(2, 0, col1);
        const col2 = {
          key: "versioncount",
          name: <FormattedMessage id="HtVersions" defaultMessage="Versions" />,
          type: TDTypeConsts.VERSIONS,
        };
        this.state.headers.push(col2);
      }
    }
    if (status == 2) {
      const col1 = this.state.headers.findIndex(
        (x) => x.key == "assignedEmployeeList",
      );
      this.state.headers.splice(col1, 1);
      const col2 = this.state.headers.findIndex((x) => x.key == "versioncount");
      this.state.headers.splice(col2, 1);
    }
  }

  _onCreate = () => {
    const { match } = this.props;
    this.props.CommonReducerAction("CLEARWEEKOFF", {});
    this.setState({ completed: [] });
    this.props.history.push(`${match.path}/create`);
    this.GetWeekoffDays(0);
  };

  getText() {
    return (
      <span>
        {this.state.value == 0 ? (
          <FormattedMessage
            id="weeklyOffConcept"
            defaultMessage="Typically, most jobs in any company come with Weekly Offs. So, as the name of this feature suggests, here you can define Weekly Off  rules for your employees. Using a combination of features, you will have the flexibility to not only define the days of the week when one can avail an off, but also choose whether it can be an half-day or a full-day off."
          />
        ) : (
          <span>
            Saved drafts allow you to store policies that you have not finished
            creating.
          </span>
        )}
      </span>
    );
  }

  _renderCreate = () => (
    <React.Fragment>
      <CreateComp
        text={this.getText()}
        heading={
          this.state.value == 0 ? "Concept of Weekoff" : "No drafts saved"
        }
        onCreate={this._onCreate}
        imageSrc={this.state.value == 0 ? WeeklyOffIMg : emptylist}
        permissions={this.state.permissions}
      />
    </React.Fragment>
  );

  showLoader() {
    return <div className="pre-loader">Loading...</div>;
  }

  _renderList = () => {
    const { WEEKOFFTPLANNER } = this.props;
    let HeadingName = "Weekly off";
    if (this.props.history.location.pathname.includes("versions")) {
      HeadingName = "Version";
    }
    return (
      <List
        list={WEEKOFFTPLANNER.Data}
        headers={this.state.headers}
        headerIndex={0}
        onCreate={this._onCreate}
        onEdit={this.onEdit}
        onVersionChange={this.onVersionChange}
        module={HeadingName}
        goTo={this.props.goTo}
        sortOrder="desc"
        permissions={this.state.permissions}
      />
    );
  };

  _renderTab = () => (
    <Grid container>
      <Grid item xs={12} md={12} sm={12}>
        <div
          position="static"
          color="default"
          className="bottom-border dashboard-tab-width"
        >
          <Grid container>
            <Grid item xs={12} md={12} sm={12}>
              {this._renderList()}
            </Grid>
          </Grid>
        </div>
      </Grid>
    </Grid>
  );

  _renderComponent = () => {
    const { WEEKOFFTPLANNER } = this.props;
    return (
      <div>
        {WEEKOFFTPLANNER.IsFulfilled && (
          <div>
            {WEEKOFFTPLANNER.Data.length == 0
              ? this._renderCreate()
              : this._renderTab()}
          </div>
        )}
      </div>
    );
  };

  _renderForm = () => {
    const { child0, child1, child2, child3 } = this.state;
    const canSaveAsDraft =
      get(this.props, "weekoffPlannerReducer.isdraft", "") ||
      !get(this.props, "weekoffPlannerReducer.weekoffpolicyid", "");
    const stepperchilds = [child0, child1, child2, child3].filter((x) => x);
    !canSaveAsDraft &&
      stepperchilds.map((x) => {
        delete x.onSaveDraft;
        return x;
      });
    return (
      <div>
        <Stepper
          AllStep={this.state.AllStep}
          onRef={(ref) => (this.child = ref)}
          completed={this.state.completed}
          setStep={this.setStep.bind(this)}
          childs={stepperchilds}
        />
        {/* <div className="draftbutton-wrapper">
        <div className="draftclosebutton1 " onClick={() => this.OnCancel()}>
          <span className="floatleft" style={{ marginLeft: 6 }}>
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width="24"
              height="24"
              viewBox="0 0 24 24"
            >
              <path d="M19 6.41L17.59 5 12 10.59 6.41 5 5 6.41 10.59 12 5 17.59 6.41 19 12 13.41 17.59 19 19 17.59 13.41 12z" />
              <path d="M0 0h24v24H0z" fill="none" />
            </svg>
          </span>
          <span className="draftclosebutton-text">Close</span>
        </div>
        {this.state.activeStep == this.state.AllStep.length - 1 ? (
          <div
            className="draftbutton-innerwrapper "
            onClick={() => this.OnSave(false)}
          >
            <span className="draftbutton-save">
              <DoneAllIcon />
              <span className="draft-option1">Save</span>
            </span>
          </div>
        ) : this.props.weekoffPlannerReducer.isdraft == true ? (
          <div
            className="draftbutton-innerwrapper "
            onClick={() => this.OnSave(true)}
          >
            <span className="draftbutton">
              <Done />
              <span className="draft-option" style={{ marginLeft: 8 }}>
                Save As Draft
              </span>
            </span>
          </div>
        ) : (
          <div
            className="draftbutton-innerwrapper"
            onClick={() => this.OnSave(false)}
          >
            <span className="draftbutton-save">
              <DoneAllIcon />
              <span className="draft-option1">Save </span>
            </span>
          </div>
        )}
      </div>
     */}
      </div>
    );
  };

  EditPreview = () => {
    console.log("666");
    this.props.history.push(`${this.props.match.path}/create`);
  };

  DeleteWeekoffPolicy() {
    const { weekoffPlannerReducer } = this.props;
    const URL = `subscription/weekoffpolicy/${weekoffPlannerReducer.weekoffpolicyid}`;
    instance
      .delete(URL)
      .then(() => {
        this.props.enqueueSnackbar("Weekoff Policy Deleted Successfully", {
          variant: "success",
        });
        this.OnCancel();
      })
      .catch((error) => {
        const CommonError = error.response
          ? error.response.data.error.message
          : error.message;
        this.props.enqueueSnackbar(CommonError, { variant: "error" });
      });
  }

  _renderView = (isversions) => {
    console.log("isversions: ", isversions);
    return (
      <Grid container>
        <Grid item xs={12} md={12} sm={12}>
          <Preview onRef={() => {}} />
          {this.state.isPreviewEdit && !isversions ? (
            <div>
              <div>
                <div className="deletebutton-wrapper">
                  <div className="deletebutton-innerwrapper">
                    {this.state.permissions.editable ? (
                      <span className="deletebutton1">
                        <span className="delete-option">
                          <span
                            style={{ float: "left", margin: "0px 8px 0px 4px" }}
                          >
                            Are you sure?
                          </span>
                          <span
                            className="cursurpointer"
                            onClick={() => this.DeleteWeekoffPolicy()}
                          >
                            <svg
                              className="message-edit cursour-pointer save-icon"
                              width="20"
                              height="20"
                              viewBox="0 0 24 24"
                            >
                              <path
                                fill="#fff"
                                d="M9 16.2l-3.5-3.5c-.39-.39-1.01-.39-1.4 0-.39.39-.39 1.01 0 1.4l4.19 4.19c.39.39 1.02.39 1.41 0L20.3 7.7c.39-.39.39-1.01 0-1.4-.39-.39-1.01-.39-1.4 0L9 16.2z"
                              />
                            </svg>
                          </span>
                          <span
                            className="cursurpointer"
                            onClick={() => this.OnCancel()}
                          >
                            <svg
                              className="message-edit cursour-pointer close-icon"
                              width="20"
                              height="20"
                              viewBox="0 0 24 24"
                              onClick={() => this.OnCancel()}
                            >
                              <path
                                fill="#fff"
                                d="M18.3 5.71c-.39-.39-1.02-.39-1.41 0L12 10.59 7.11 5.7c-.39-.39-1.02-.39-1.41 0-.39.39-.39 1.02 0 1.41L10.59 12 5.7 16.89c-.39.39-.39 1.02 0 1.41.39.39 1.02.39 1.41 0L12 13.41l4.89 4.89c.39.39 1.02.39 1.41 0 .39-.39.39-1.02 0-1.41L13.41 12l4.89-4.89c.38-.38.38-1.02 0-1.4z"
                              />
                            </svg>
                          </span>
                        </span>

                        <svg
                          className="delete-svg"
                          width="24"
                          height="24"
                          viewBox="0 0 24 24"
                        >
                          <path fill="none" d="M0 0h24v24H0V0z" />
                          <path d="M6 19c0 1.1.9 2 2 2h8c1.1 0 2-.9 2-2V7H6v12zM8 9h8v10H8V9zm7.5-5l-1-1h-5l-1 1H5v2h14V4h-3.5z" />
                        </svg>
                      </span>
                    ) : (
                      ""
                    )}
                  </div>
                </div>
                <div className="draftbutton-wrapper">
                  <div
                    className="draftclosebutton cursour-pointer"
                    onClick={() => this.OnCancel()}
                  >
                    <span className="floatleft" style={{ marginLeft: 6 }}>
                      <svg
                        xmlns="http://www.w3.org/2000/svg"
                        width="24"
                        height="24"
                        viewBox="0 0 24 24"
                      >
                        <path d="M19 6.41L17.59 5 12 10.59 6.41 5 5 6.41 10.59 12 5 17.59 6.41 19 12 13.41 17.59 19 19 17.59 13.41 12z" />
                        <path d="M0 0h24v24H0z" fill="none" />
                      </svg>
                    </span>
                    <span className="draftclosebutton-text">Close</span>
                  </div>
                  {this.state.permissions.editable &&
                  this.state.isPreviewEdit &&
                  !isversions ? (
                    <div className="draftbutton-innerwrapper cursour-pointer">
                      <span
                        className="editbutton"
                        onClick={() => this.EditPreview()}
                      >
                        <span className="edit-option">Edit &nbsp; &nbsp;</span>
                        <svg width="24" height="24" viewBox="0 0 24 24">
                          <path d="M3 17.25V21h3.75L17.81 9.94l-3.75-3.75L3 17.25zM20.71 7.04c.39-.39.39-1.02 0-1.41l-2.34-2.34c-.39-.39-1.02-.39-1.41 0l-1.83 1.83 3.75 3.75 1.83-1.83z" />
                          <path d="M0 0h24v24H0z" fill="none" />
                        </svg>
                      </span>
                    </div>
                  ) : (
                    ""
                  )}
                </div>
              </div>
            </div>
          ) : (
            // <Button
            //   className="margin-top-8"
            //   color="primary"
            //   variant="contained"
            //   onClick={() => this.BackFromVersionViewMode()}
            // >
            //   Back
            // </Button>
            <div className="draftbutton-wrapper">
              <div
                className="draftclosebutton cursour-pointer"
                onClick={() => this.OnCancel()}
              >
                <span className="floatleft" style={{ marginLeft: 6 }}>
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width="24"
                    height="24"
                    viewBox="0 0 24 24"
                  >
                    <path d="M19 6.41L17.59 5 12 10.59 6.41 5 5 6.41 10.59 12 5 17.59 6.41 19 12 13.41 17.59 19 19 17.59 13.41 12z" />
                    <path d="M0 0h24v24H0z" fill="none" />
                  </svg>
                </span>
                <span className="draftclosebutton-text">Close</span>
              </div>
            </div>
          )}
        </Grid>
      </Grid>
    );
  };

  BackFromVersionListMode = () => {
    this.props.history.push("./list");
  };

  _renderVersion = () => (
    <Grid container>
      <Button
        className="margin-bottom-8"
        color="primary"
        variant="contained"
        onClick={this.BackFromVersionListMode}
      >
        Back
      </Button>
      <Grid item xs={12} md={12} sm={12}>
        {this._renderList()}
      </Grid>
    </Grid>
  );

  onClick = () => {
    this.child.handleNext();
  };

  StepError(step, error) {
    const index = this.state.AllStep.findIndex((x) => x.step == step);
    const { AllStep } = this.state;
    AllStep[index].isError = error;
    this.setState({ AllStep });
  }

  onEdit = (item, isPreviewEdit) => {
    this.setState({ isPreviewEdit });
    this.GetWeekoffDetails(item.weekoffpolicyid);
  };

  onPrevClick = () => {
    this.child.handleBack();
  };

  OnSaveDraft = () => {
    this.OnSave(true);
  };

  OnSave = (isdraft = false) => {
    const { value } = this.state;
    const isdrafttemp = isdraft == true ? true : false;
    const weekoffPlannerInfo = this.props.weekoffPlannerReducer;
    if (!weekoffPlannerInfo.weekoffpolicyname) {
      this.props.enqueueSnackbar("Weekly-off Name can not be empty", {
        variant: "error",
      });
    } else if (!this.ValidateAllSteps()) {
      this.props.enqueueSnackbar("Please provide valid information", {
        variant: "error",
      });
    } else {
      weekoffPlannerInfo.isdraft = isdrafttemp;
      weekoffPlannerInfo.weekoffdetail =
        weekoffPlannerInfo.weekoffdetail.filter(
          (x) => x.fullweekoffids || x.halfweekoffids,
        );
      delete weekoffPlannerInfo.weekoffdays;
      const URL = "subscription/weekoffpolicy";
      instance
        .post(URL, weekoffPlannerInfo)
        .then((result) => {
          if (isdraft == true) {
            weekoffPlannerInfo.weekoffpolicyid = get(
              result,
              "data.result[0].weekoffpolicyid",
              "",
            );
            this.props.WeekoffPlanner({ ...weekoffPlannerInfo });
            this.props.enqueueSnackbar(
              "Weekly off policy saved as a draft successfully",
              {
                variant: "success",
              },
            );
            // if (this.props.WEEKOFFTPLANNER.Data.length == 0) {
            //   this.props.history.push("/config/track/leave/weeklyoff/list");
            //   // this.setState({ value: 0 });
            // } else {
            //   this.props.history.push("/config/track/leave/weeklyoff/list");
            //   // this.setState({ value: 1 });
            // }
            this.props.history.push("/config/track/leave/weeklyoff/list");
          } else {
            this.props.enqueueSnackbar("Weekly off policy saved successfully", {
              variant: "success",
            });
            this.props.history.push("/config/track/leave/weeklyoff/list");
            // this.setState({ value: 0 });
            this.OnCancel();
          }
          this.props.history.push("./list");
          // this.setState({ value: isdrafttemp ? }, () => {
          this.props.CommonApiAction(
            ApiReducerType.WEEKOFFTPLANNER,
            "get",
            `subscription/getallweekoffpolicy/${value == 1 ? "2" : "1"}`,
            {},
          );
          // });
        })
        .catch((error) => {
          const CommonError = error.response
            ? error.response.data.error.message
            : error.message;
          this.props.enqueueSnackbar(CommonError, { variant: "error" });
        });

      this.props.CommonApiAction(
        ApiReducerType.WEEKOFFTPLANNER,
        "get",
        "subscription/getallweekoffpolicy/2",
        {},
      );
    }
  };

  getAPIData = (url) =>
    instance.get(url).then(
      (response) =>
        // // console.log(response, 'aya res');
        response,
      () => false,
    );

  GetWeekoffDetails(weekoffpolicyid) {
    return new Promise((resolve, reject) => {
      console.log("resolve, reject: ", resolve, reject);
      const promise1 = this.getAPIData(
        `/subscription/weekoffpolicy/${weekoffpolicyid}`,
      );
      const promise2 = this.getAPIData(
        `/subscription/weekoffpolicydetail/${weekoffpolicyid}`,
      );
      // const promise3 = getAPIData('subscription/businessunit/45');
      Promise.all([promise1, promise2]).then((results) => {
        let weekoffPlannerInfo = {
          weekoffdays: [],
        };
        weekoffPlannerInfo = {
          ...weekoffPlannerInfo,
          ...results[0].data.result[0],
        };
        weekoffPlannerInfo.weekoffdays = results[1].data.result;
        this.props.WeekoffPlanner({ ...weekoffPlannerInfo });
        console.log("777");
        console.log("aft 777", this.props.location.pathname);
        if (this.props.location.pathname.includes("/versions")) {
          this.props.history.push(`${this.props.match.path}/versions/view`);
        } else {
          this.props.history.push(`${this.props.match.path}/view`);
        }
        // let ispreview = t rue
        this.CheckActiveSteps(true);
        // // console.log(values, 'values')
        // resolve(getFormConfig(values[0].data.result, values[1].data.result, initialData, subscriptionid));
      });
    });
    // let weekoffPlannerInfo = this.props.weekoffPlannerReducer;
    // if (weekoffpolicyid) {
    //     let URL = `/subscription/weekoffpolicy/${weekoffpolicyid}`
    //     // this.props.CommonReducerAction('CLEARWEEKOFF', {})
    //     instance.get(URL).then(result => {

    //         weekoffPlannerInfo = result.data.result[0]
    //         this.props.WeekoffPlanner({ ...weekoffPlannerInfo })
    //         this.props.history.push(`${this.props.match.path}/create`)
    //         this.CheckActiveSteps();
    //     }).catch(error => {
    //         let CommonError = error.response
    //             ? error.response.data.error.message
    //             : error.message;
    //         this.props.enqueueSnackbar(CommonError, { variant: 'error' })
    //     })

    //     this.GetWeekoffDays(weekoffpolicyid)
    // URL = `/subscription/weekoffpolicydetail/${weekoffpolicyid}`
    // this.props.CommonReducerAction('CLEARWEEKOFF', {})
    // instance.get(URL).then(result => {
    //     weekoffPlannerInfo.weekoffdays = result.data.result
    //     this.props.WeekoffPlanner({ ...weekoffPlannerInfo })

    // }).catch(error => {
    //     let CommonError = error.response
    //         ? error.response.data.error.message
    //         : error.message;
    //     this.props.enqueueSnackbar(CommonError, { variant: 'error' })
    // })
    // }
  }

  GetWeekoffDays(weekoffpolicyid) {
    if (weekoffpolicyid > 0) {
      // let weekoffpolicyid = weekoffPlannerInfo.weekoffpolicyid;
      const URL = `/subscription/weekoffpolicydetail/${weekoffpolicyid}`;
      // this.props.CommonReducerAction('CLEARWEEKOFF', {})
      instance
        .get(URL)
        .then((result) => {
          const weekoffPlannerInfo = this.props.weekoffPlannerReducer;
          weekoffPlannerInfo.weekoffdays = result.data.result;
          this.props.WeekoffPlanner({ ...weekoffPlannerInfo });
          this.props.history.push(`${this.props.match.path}/view`);
          const ispreview = true;
          this.CheckActiveSteps(ispreview);
        })
        .catch((error) => {
          const CommonError = error.response
            ? error.response.data.error.message
            : error.message;
          this.props.enqueueSnackbar(CommonError, { variant: "error" });
        });
    }
  }

  ValidateAllSteps() {
    let isValid;
    const filteredArray = this.state.AllStep.filter(
      (array) => array.isError == true,
    );
    if (filteredArray.length != 0) {
      isValid = false;
    } else {
      isValid = true;
    }
    return isValid;
  }

  OnCancel = () => {
    const { AllStep } = this.state;
    for (const step of AllStep) {
      step.isError = false;
    }
    this.setState({ AllStep, activeStep: "" });

    let status;
    this.state.value == 0
      ? (status = 1)
      : this.state.value == 1
      ? (status = 2)
      : (status = 0);

    status == 1
      ? this.props.CommonApiAction(
          ApiReducerType.WEEKOFFTPLANNER,
          "get",
          "subscription/getallweekoffpolicy/1",
          {},
        )
      : this.props.CommonApiAction(
          ApiReducerType.WEEKOFFTPLANNER,
          "get",
          "subscription/getallweekoffpolicy/2",
          {},
        );

    this.props.history.push("./list");
  };

  CheckActiveSteps(ispreview) {
    const completed = {};
    const weekoffPlannerInfo = this.props.weekoffPlannerReducer;
    if (!this.isEmpty(weekoffPlannerInfo)) {
      // if(weekoffPlannerInfo.devicepolicyid){
      weekoffPlannerInfo.weekoffpolicyname != undefined
        ? (completed[0] = true)
        : (completed[0] = false);
      weekoffPlannerInfo.weekoffdays != undefined &&
      weekoffPlannerInfo.weekoffdays.length > 0
        ? (completed[1] = true)
        : (completed[1] = false);
      weekoffPlannerInfo.isaccumulation != undefined
        ? (completed[2] = true)
        : (completed[2] = false);
      weekoffPlannerInfo.isdraft == false && ispreview == true
        ? (completed[3] = true)
        : (completed[3] = false);
      // }
    }
    this.setState({ completed });
  }

  isEmpty(obj) {
    Object.keys(obj).forEach((key) => {
      // eslint-disable-next-line no-prototype-builtins
      if (Object.prototype.hasOwnProperty.call(obj, key)) return false;
    });
    return true;
  }

  setStep(step, completed) {
    this.setState({ activeStep: step, completed });
  }

  render() {
    const { classes, match } = this.props;
    const language = this.props.Language.weekoff;

    return (
      <IntlProvider locale="en" messages={language}>
        <div className="innerwrapper-full-width">
          <Helmet>
            <title>{headersList.Config.WeeklyOff.header}</title>
          </Helmet>
          {this.state.permissiondenied ? (
            <div className="position-rel">
              <PermissionDeniedComp />
            </div>
          ) : (
            <div>
              <div>
                {this.props.history.location.pathname ===
                  "/config/track/leave/weeklyoff/list" && (
                  <div className="common-menubar-header">
                    <Tabs
                      value={this.state.value}
                      onChange={this.handleChange.bind(this)}
                      indicatorColor="#fff"
                      textColor="primary"
                      scrollButtons="auto"
                    >
                      <Tab
                        label={
                          <FormattedMessage
                            id="HtActive"
                            defaultMessage="Active"
                          />
                        }
                        className={`tabheading ${
                          this.state.value == 0
                            ? "active-tab1"
                            : "inactive-tab1"
                        } `}
                      />
                      <Tab
                        label={
                          <FormattedMessage
                            id="HtDraft"
                            defaultMessage="Draft"
                          />
                        }
                        className={`tabheading ${
                          this.state.value == 1
                            ? "active-tab1"
                            : "inactive-tab1"
                        } `}
                      />
                    </Tabs>
                    <div className="tab-border" />
                  </div>
                )}
              </div>
              <main className="content-outer-wrapper-with-tab">
                <div className={classes.root}>
                  <Grid container>
                    <Grid item xs={12} md={12} sm={12}>
                      <div className="shiftplanner-forms">
                        <Switch>
                          <Route
                            exact
                            path={`${match.path}/create`}
                            render={this._renderForm}
                          />
                          <Route
                            exact
                            path={`${match.path}/versions`}
                            render={this._renderVersion}
                          />
                          <Route
                            exact
                            path={`${match.path}/list`}
                            render={this._renderComponent}
                          />
                          <Route
                            exact
                            path={`${match.path}/`}
                            render={this._renderComponent}
                          />
                          <Route
                            exact
                            path={`${match.path}/view`}
                            render={() => this._renderView(false)}
                          />
                          <Route
                            exact
                            path={`${match.path}/versions/view`}
                            render={() => this._renderView(true)}
                          />
                          <Route path="**" component={PageNotFound} />
                        </Switch>
                      </div>
                    </Grid>
                  </Grid>
                </div>
              </main>
            </div>
          )}
        </div>
      </IntlProvider>
    );
  }
}

const mapStateToProps = (state) => ({
  WEEKOFFTPLANNER: state.WEEKOFFTPLANNER,
  weekoffPlannerReducer: state.weekoffPlannerReducer,
  Language: state.LanguageAction.Language,
});

const mapDispatchToProps = (dispatch) =>
  bindActionCreators(
    {
      ChangeLanguage: (data) => ChangeLanguage(data),
      WeekoffPlanner: (data) => WeekoffPlanner(data),
      CommonReducerAction: (type, data) => CommonReducerAction(type, data),
      CommonApiAction: (type, method, url, data) =>
        CommonApiAction(type, method, url, data),
    },
    dispatch,
  );

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(withStyles(styles, { withTheme: true })(withSnackbar(WeeklyOff)));
